import api from './api';

export const loansService = {
  // Obtener todos los préstamos
  async getAll() {
    try {
      const response = await api.get('/loans');
      return response.data;
    } catch (error) {
      console.error('Error getting loans:', error);
      throw error;
    }
  },

  // Obtener un préstamo por ID
  async getById(id) {
    try {
      const response = await api.get(`/loans/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error getting loan by ID:', error);
      throw error;
    }
  },

  // Crear un nuevo préstamo
  async create(loanData) {
    try {
      const response = await api.post('/loans', loanData);
      return response.data;
    } catch (error) {
      console.error('Error creating loan:', error);
      throw error;
    }
  },

  // Actualizar un préstamo
  async update(id, loanData) {
    try {
      console.log('🔄 Enviando actualización de préstamo al servidor:', { id, data: loanData });
      const response = await api.put(`/loans/${id}`, loanData);
      console.log('✅ Respuesta de actualización del servidor:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating loan:', error);
      throw error;
    }
  },

  // Eliminar un préstamo
  async delete(id) {
    try {
      const response = await api.delete(`/loans/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting loan:', error);
      throw error;
    }
  },

  // Devolver un préstamo
  async returnLoan(id) {
    try {
      const response = await api.post(`/loans/${id}/return`);
      return response.data;
    } catch (error) {
      console.error('Error returning loan:', error);
      throw error;
    }
  },

  // Obtener estadísticas de préstamos
  async getStats() {
    try {
      const response = await api.get('/loans/stats');
      return response.data;
    } catch (error) {
      console.error('Error getting loan stats:', error);
      throw error;
    }
  }
};